/* USERS */
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"
export const CLEAR_USERS = "CLEAR_USERS"

export const GET_USER_DETAIL = "GET_USER_DETAIL"
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS"
export const GET_USER_DETAIL_FAIL = "GET_USER_DETAIL_FAIL"
export const CLEAR_USER_DETAIL = "CLEAR_USER_DETAIL"

export const MANAGE_USER = "MANAGE_USER"
export const MANAGE_USER_SUCCESS = "MANAGE_USER_SUCCESS"
export const MANAGE_USER_FAIL = "MANAGE_USER_FAIL"
export const CLEAR_MANAGE_ERROR = "CLEAR_MANAGE_ERROR"

export const GET_AUTHORIZATION_GROUPS = "GET_AUTHORIZATION_GROUPS"
export const GET_AUTHORIZATION_GROUPS_SUCCESS = "GET_AUTHORIZATION_GROUPS_SUCCESS"
export const GET_AUTHORIZATION_GROUPS_FAIL = "GET_AUTHORIZATION_GROUPS_FAIL"
